module.exports = __webpack_public_path__ + "img/logo-ne_badge.47cfea2d.png";